import { IconKcal, IconVol, IconGluten, IconDownload } from "@/components/icon/master"
import { ReactNode } from "react"
import { TCocktailDetailProps } from "../type"
import { TCocktail } from "@/shared/types"

export function CocktailBaseInfo(props: {
    children: ReactNode
} & TCocktailDetailProps & { cocktailInfo: TCocktail }) {
    const { children, cocktailInfo } = props
    return (
        <div className="cocktail-base-info-wrapper">
            <div className="cocktail-base-content">
                <div className="cocktial-type">
                    {cocktailInfo?.brandName?.replaceAll(',', ', ')}
                </div>
                <h1 className="cocktail-name">{cocktailInfo.cocktailTitle}</h1>
                <div className="cocktail-tags-list">
                    {
                        cocktailInfo.calorie && <div className="cocktail-tag">
                            <IconKcal />
                            <span className="tag-text calories">{cocktailInfo.calorie} {props.unitCalories}</span>
                        </div>
                    }
                    {/* {
                        cocktailInfo.alcoholVol && <div className="cocktail-tag">
                            <IconVol />
                            <span className="tag-text volume">{cocktailInfo.alcoholVol}{props.unitVol}</span>
                        </div>
                    } */}
                    {/* <div className="cocktail-tag">
                        <IconGluten />
                        <span className="tag-text gluten">-Gluten</span>
                    </div> */}
                </div>
                <div className="cocktail-description" dangerouslySetInnerHTML={{ __html: cocktailInfo.cocktailDescriptionBig || '' }}>
                </div>
                {children}
            </div>
            {
                cocktailInfo?.recipeFirstImage?.url && <div className="cocktail-media-wrapper">
                    <img src={cocktailInfo?.recipeFirstImage?.url} alt={cocktailInfo?.cocktailTitle} />
                    <div className="cocktail-text">
                        {props.verticalText}
                    </div>
                </div>
            }

        </div>
    )
}